import React, { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { MONTH_NAMES } from "../../constants";
// import extractUrlParams from "../../helpers/extract-url-params";
// import GetProductsData from "../../hooks/get-products";
import Banner from "../../components/Banner";
import Products from "../../components/Products";
import TopProducts from "../../components/TopProducts";
import { GlobalStateContext } from "../../context/GlobalStateContext";
import GetLevantaProductsData from "../../hooks/get-levanta-products";
import HeroBlock from "../../components/Hero";

const Home = ({ categoriesList, categoriesError }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [queryParameters] = useSearchParams();
  const banner = useSelector((state) => state.dataUploader.banner);
  const currentCategory = useSelector(
    (state) => state.dataUploader.currentCategoryData,
  );
  const defaultCategory = useSelector(
    (state) => state.dataUploader.defaultCategoryData,
  );
  const headerCurrentCategory = useSelector(
    (state) => state.dataUploader.headerCurrentCategory,
  );
  const allCategories = useSelector(
    (state) => state.dataUploader.allCategories,
  );
  const [date, setDate] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [dataPage, setDataPage] = useState(2);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [error, setError] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [errorMessage, setErrorMessage] = useState("");
  const [searchTitle, setSearchTitle] = useState("");
  const triggerLoadingMoreProducts = useRef(null);

  const {
    searchResults,
    setSearchResults,
    sugestedProducts,
    setSugestedProducts,
    productsList,
    setProductsList,
    loading,
    setLoading,
  } = useContext(GlobalStateContext);

  const location = useLocation();

  useEffect(() => {
    document.title = "Home";

    const queryString = location.search;
    if (queryString !== "") {
      localStorage.setItem("url-params", queryString);
    }
  }, [pathname, sugestedProducts]);

  useEffect(() => {
    if (searchResults.length > 0) {
      setProductsList(searchResults);
    }

    if (sugestedProducts.length > 0) {
      setProductsList([]);

      const savedParams = localStorage.getItem("url-params") ?? "";
      const params = new URLSearchParams(savedParams);
      params.delete("lid");
      const queryParams = "?" + params.toString();

      window.location.href = `/lpv/connexity-related-products${queryParams}`;
    }
  }, [searchResults, sugestedProducts]);

  useEffect(() => {
    const today = new Date();
    const currentMonth = MONTH_NAMES[today.getMonth()];
    const currentDay = today.getDate();
    setDate(`${currentMonth} ${currentDay}`);
  }, []);

  useEffect(() => {
    let id, provider;
    const params = { limit: 8, offset: 0 };
    setDataPage(1);
    setSugestedProducts([]);
    setSearchResults([]);
    GetLevantaProductsData(
      setLoading,
      setError,
      setErrorMessage,
      setProductsList,
      params,
      id,
      setHasMore,
      dispatch,
    );

    if (allCategories.length > 0) {
      if (searchResults.length === 0) {
        GetLevantaProductsData(
          setLoading,
          setError,
          setErrorMessage,
          setProductsList,
          params,
          id,
          setHasMore,
          dispatch,
        );
      } else {
        setLoading(false);
      }
    }
  }, [allCategories, queryParameters, currentCategory, headerCurrentCategory]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="main-wrapper">
      <HeroBlock
        titleText={"Browse The Best Amazon Deals and Offers"}
      />
      {/* <Banner 
                titleText={`Hottest Deals For: ${date}`} 
                setSearchResults={setSearchResults} 
                setSugestedProducts={setSugestedProducts}
                searchResults={searchResults} 
                sugestedProducts={sugestedProducts} 
                setProductsList={setProductsList} 
                setLoading={setLoading}
                setSearchTitle={setSearchTitle}
            /> */}
      {!error && !categoriesError ? (
        <div className="axil-shop-area axil-section-gap bg-color-white main-container">
          <div id="main">
            {/* {window.innerWidth <= 992 ?
                            <div className="products-title section-title-wrapper">
                                <h2 className="title">Hottest Deals For: {date}</h2>
                            </div> :
                            null
                        } */}
            <h1 className="axil-shop-area-title">Trending Offers</h1>

            {!loading ? (
              <>
                <div className="products-with-side-banners">
                  <img
                    className="side-banner side-banner-left"
                    src="/images/banner/left-right.webp"
                    alt="Special offer"
                  />

                  <Products
                    categories={categoriesList}
                    data={productsList}
                    setData={setProductsList}
                    triggerLoadingMoreProducts={triggerLoadingMoreProducts}
                    loadingProducts={loadingProducts}
                    setLoadingProducts={setLoadingProducts}
                    hasMore={hasMore}
                    setHasMore={setHasMore}
                    dataPage={dataPage}
                    setDataPage={setDataPage}
                    searchResults={searchResults}
                    sugestedProducts={sugestedProducts}
                    setSugestedProducts={setSugestedProducts}
                    searchTitle={searchTitle}
                  />
                  <img
                    src="/images/banner/left-right.webp"
                    alt="Special offer"
                    className="side-banner side-banner-right"
                  />
                </div>

                <div className="promo">
                  <picture className="promo-bg">
                    <source
                      media="(max-width: 767px)"
                      srcSet={"/images/promo/promo-mobile.webp"}
                    />
                    <img
                      src={"/images/promo/promo.webp"}
                      alt="Hero background"
                    />
                  </picture>
                </div>
              </>
            ) : (
              <div className="loader-container">
                <span className="loader"></span>
              </div>
            )}
            {!loading ? (
              <div className="container">
                <TopProducts data={productsList} />
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="axil-shop-area axil-section-gap bg-color-white">
          <div id="main" className="container">
            <div>{errorMessage}</div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Home;
